import {
  Component,
  ViewChild,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';

@Component({
  selector: 'app-wizardpage-step3-contact',
  templateUrl: './wizardpage-step3.component.html',
  styleUrls: ['./wizardpage-step3.component.scss'],
})
export class WizardpageStep3ContactComponent implements OnInit {
  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function

  isSubmitted = false;
  disablePastName = false; // set it to false initially so box is not disabled
  disablePastAddress = false; // set it to false initially so box is not disabled
  initForm: any;
  isfetching: boolean;
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  nametypes = [
    {
      name: 'Maiden',
      value: 'Maiden',
    },
    {
      name: 'ALIAS',
      value: 'ALIAS',
    },
    {
      name: 'Other',
      value: 'Other',
    },
  ];

  casetypes = [
    {
      name: 'Nassau County DSS',
      value: 'NCD',
    },
    {
      name: 'NYC 5 Boroughs MLTC',
      value: 'NYB',
    },
    {
      name: 'Suffolk County DSS',
      value: 'SCD',
    },
    {
      name: 'Upstate NY MLTC',
      value: 'UPNY',
    },
    {
      name: 'Westchester - Long Isl_MLTC',
      value: 'WEST',
    },
  ];

  states = [
    {
      name: 'Alabama',
      abbreviation: 'AL',
    },
    {
      name: 'Alaska',
      abbreviation: 'AK',
    },
    {
      name: 'American Samoa',
      abbreviation: 'AS',
    },
    {
      name: 'Arizona',
      abbreviation: 'AZ',
    },
    {
      name: 'Arkansas',
      abbreviation: 'AR',
    },
    {
      name: 'California',
      abbreviation: 'CA',
    },
    {
      name: 'Colorado',
      abbreviation: 'CO',
    },
    {
      name: 'Connecticut',
      abbreviation: 'CT',
    },
    {
      name: 'Delaware',
      abbreviation: 'DE',
    },
    {
      name: 'District Of Columbia',
      abbreviation: 'DC',
    },
    {
      name: 'Federated States Of Micronesia',
      abbreviation: 'FM',
    },
    {
      name: 'Florida',
      abbreviation: 'FL',
    },
    {
      name: 'Georgia',
      abbreviation: 'GA',
    },
    {
      name: 'Guam',
      abbreviation: 'GU',
    },
    {
      name: 'Hawaii',
      abbreviation: 'HI',
    },
    {
      name: 'Idaho',
      abbreviation: 'ID',
    },
    {
      name: 'Illinois',
      abbreviation: 'IL',
    },
    {
      name: 'Indiana',
      abbreviation: 'IN',
    },
    {
      name: 'Iowa',
      abbreviation: 'IA',
    },
    {
      name: 'Kansas',
      abbreviation: 'KS',
    },
    {
      name: 'Kentucky',
      abbreviation: 'KY',
    },
    {
      name: 'Louisiana',
      abbreviation: 'LA',
    },
    {
      name: 'Maine',
      abbreviation: 'ME',
    },
    {
      name: 'Marshall Islands',
      abbreviation: 'MH',
    },
    {
      name: 'Maryland',
      abbreviation: 'MD',
    },
    {
      name: 'Massachusetts',
      abbreviation: 'MA',
    },
    {
      name: 'Michigan',
      abbreviation: 'MI',
    },
    {
      name: 'Minnesota',
      abbreviation: 'MN',
    },
    {
      name: 'Mississippi',
      abbreviation: 'MS',
    },
    {
      name: 'Missouri',
      abbreviation: 'MO',
    },
    {
      name: 'Montana',
      abbreviation: 'MT',
    },
    {
      name: 'Nebraska',
      abbreviation: 'NE',
    },
    {
      name: 'Nevada',
      abbreviation: 'NV',
    },
    {
      name: 'New Hampshire',
      abbreviation: 'NH',
    },
    {
      name: 'New Jersey',
      abbreviation: 'NJ',
    },
    {
      name: 'New Mexico',
      abbreviation: 'NM',
    },
    {
      name: 'New York',
      abbreviation: 'NY',
    },
    {
      name: 'North Carolina',
      abbreviation: 'NC',
    },
    {
      name: 'North Dakota',
      abbreviation: 'ND',
    },
    {
      name: 'Northern Mariana Islands',
      abbreviation: 'MP',
    },
    {
      name: 'Ohio',
      abbreviation: 'OH',
    },
    {
      name: 'Oklahoma',
      abbreviation: 'OK',
    },
    {
      name: 'Oregon',
      abbreviation: 'OR',
    },
    {
      name: 'Palau',
      abbreviation: 'PW',
    },
    {
      name: 'Pennsylvania',
      abbreviation: 'PA',
    },
    {
      name: 'Puerto Rico',
      abbreviation: 'PR',
    },
    {
      name: 'Rhode Island',
      abbreviation: 'RI',
    },
    {
      name: 'South Carolina',
      abbreviation: 'SC',
    },
    {
      name: 'South Dakota',
      abbreviation: 'SD',
    },
    {
      name: 'Tennessee',
      abbreviation: 'TN',
    },
    {
      name: 'Texas',
      abbreviation: 'TX',
    },
    {
      name: 'Utah',
      abbreviation: 'UT',
    },
    {
      name: 'Vermont',
      abbreviation: 'VT',
    },
    {
      name: 'Virgin Islands',
      abbreviation: 'VI',
    },
    {
      name: 'Virginia',
      abbreviation: 'VA',
    },
    {
      name: 'Washington',
      abbreviation: 'WA',
    },
    {
      name: 'West Virginia',
      abbreviation: 'WV',
    },
    {
      name: 'Wisconsin',
      abbreviation: 'WI',
    },
    {
      name: 'Wyoming',
      abbreviation: 'WY',
    },
  ];

  constructor() {}

  @Input() regForm: UntypedFormGroup;

  ngOnInit(): void {


this.initForm = this.regForm.value;
this.isfetching = false;
this.pastAddressClick(this.regForm.get('pstaddress').value);
this.pastNameClick(this.regForm.get('pstname').value);


  }




  decreasePage() {
    this.pagecountevnt.emit(0);
  }


  pastNameClick(x) {
    if (x === 'Yes') {
      this.regForm.get('pastname1').enable();
      this.regForm.get('txtpastname1').enable();
      this.regForm.get('pastname2').enable();
      this.regForm.get('txtpastname2').enable();
      this.regForm.get('pastname3').enable();
      this.regForm.get('txtpastname3').enable();
    } else {
      this.regForm.get('pastname1').disable();
      this.regForm.get('pastname1').setValue('Please Choose...');

      this.regForm.get('txtpastname1').disable();
      this.regForm.get('txtpastname1').setValue('');

      this.regForm.get('pastname2').disable();
      this.regForm.get('pastname2').setValue('Please Choose...');

      this.regForm.get('txtpastname2').disable();
      this.regForm.get('txtpastname2').setValue('');

      this.regForm.get('pastname3').disable();
      this.regForm.get('pastname3').setValue('Please Choose...');

      this.regForm.get('txtpastname3').disable();
      this.regForm.get('txtpastname3').setValue('');
    }
  }

  pastAddressClick(x) {
    if (x === 'Yes') {
      this.regForm.get('txtpastaddress1').enable();
      this.regForm.get('txtpastaddressdate1').enable();
      this.regForm.get('txtpastaddress2').enable();
      this.regForm.get('txtpastaddressdate2').enable();
      this.regForm.get('txtpastaddress3').enable();
      this.regForm.get('txtpastaddressdate3').enable();
    } else {
      this.regForm.get('txtpastaddress1').disable();
      this.regForm.get('txtpastaddress1').setValue('');

      this.regForm.get('txtpastaddressdate1').disable();
      this.regForm.get('txtpastaddressdate1').setValue('');

      this.regForm.get('txtpastaddress2').disable();
      this.regForm.get('txtpastaddress2').setValue('');

      this.regForm.get('txtpastaddressdate2').disable();
      this.regForm.get('txtpastaddressdate2').setValue('');

      this.regForm.get('txtpastaddress3').disable();
      this.regForm.get('txtpastaddress3').setValue('');

      this.regForm.get('txtpastaddressdate3').disable();
      this.regForm.get('txtpastaddressdate3').setValue('');
    }
  }

  step2Submitted(postValue: UntypedFormGroup) {
    const documentA = this.initForm;
    const documentB = postValue.value;



    const jsonpatchobject = compare(documentA, documentB);


    this.regForm.get('address').markAsTouched();
    this.regForm.get('address').updateValueAndValidity();
    this.regForm.get('city').markAsTouched();
    this.regForm.get('city').updateValueAndValidity();
    this.regForm.get('state').markAsTouched();
    this.regForm.get('state').updateValueAndValidity();
    this.regForm.get('zip').markAsTouched();
    this.regForm.get('zip').updateValueAndValidity();
    this.regForm.get('pstname').markAsTouched();

    this.regForm.get('pastname1').markAsTouched();
    this.regForm.get('pastname1').updateValueAndValidity();
    this.regForm.get('pastname2').markAsTouched();
    this.regForm.get('pastname2').updateValueAndValidity();
    this.regForm.get('pastname3').markAsTouched();
    this.regForm.get('pastname3').updateValueAndValidity();


    this.regForm.get('txtpastname1').markAsTouched();
    this.regForm.get('txtpastname1').updateValueAndValidity();
    this.regForm.get('txtpastname2').markAsTouched();
    this.regForm.get('txtpastname2').updateValueAndValidity();
    this.regForm.get('txtpastname3').markAsTouched();
    this.regForm.get('txtpastname3').updateValueAndValidity();


    this.regForm.get('txtpastaddress1').markAsTouched();
    this.regForm.get('txtpastaddress1').updateValueAndValidity();
    this.regForm.get('txtpastaddress2').markAsTouched();
    this.regForm.get('txtpastaddress2').updateValueAndValidity();
    this.regForm.get('txtpastaddress3').markAsTouched();
    this.regForm.get('txtpastaddress3').updateValueAndValidity();




    this.regForm.get('pstaddress').markAsTouched();
    this.regForm.get('pstaddress').updateValueAndValidity();

    this.regForm.get('txtpastaddressdate1').markAsTouched();
    this.regForm.get('txtpastaddressdate1').updateValueAndValidity();
    this.regForm.get('txtpastaddressdate2').markAsTouched();
    this.regForm.get('txtpastaddressdate2').updateValueAndValidity();
    this.regForm.get('txtpastaddressdate3').markAsTouched();
    this.regForm.get('txtpastaddressdate3').updateValueAndValidity();






    this.isSubmitted = true;
    if (!this.regForm.valid) {
      return false;
    } else {
      // the is the event property of the template emitting the validation value to the parent component
      this.isfetching = true;
      this.continueevnt.emit(jsonpatchobject);
      this.pagecountevnt.emit(1);

      return true;
    }
  }


  isFetching(e) {
    this.isfetching = e; }
}
